/* SAINT SKEI – size selector style "Neu (Gleitend)" (Anton 2026-11-02, inspired by the Zeekr model selector).
   Only active when the variant picker block setting "Stil des Variantenselektors" = "sliding"
   (class .product-variant--ss-sliding). Adds one decorative white block (.ss-variant-pill) inside the
   #F5F3F3 track and moves it under the checked size card. Pure decoration: the radio inputs, labels, prices,
   sold-out states and the theme's variant logic are untouched. The block follows every way the variant can change
   (click, keyboard, sticky size picker, URL/theme updates via the checked attribute, re-rendered product page)
   and is re-measured on resize / scroll-row layout. prefers-reduced-motion: no slide (CSS). */
(function () {
  'use strict';
  if (window.__ssVariantPill) return;
  window.__ssVariantPill = true;

  var TRACK = '.product-variant--ss-sliding [data-js-product-variant-container="radio"]';
  var ro = 'ResizeObserver' in window ? new ResizeObserver(function (entries) {
    entries.forEach(function (e) {
      var t = e.target.closest ? e.target.closest(TRACK) || e.target : e.target;
      if (t.__ssPill) schedule(t, false);
    });
  }) : null;

  function checkedLabel(track) {
    var input = track.querySelector('input.product-variant__input:checked');
    if (!input) return null;
    var item = input.closest('.product-variant__item');
    return item ? item.querySelector('label') : null;
  }

  function place(track, animate) {
    var pill = track.__ssPill;
    if (!pill) return;
    var label = checkedLabel(track);
    if (!label || !label.getClientRects().length || !track.getClientRects().length) {
      pill.style.opacity = '0';
      return;
    }
    var tr = track.getBoundingClientRect();
    var lr = label.getBoundingClientRect();
    var x = lr.left - tr.left - track.clientLeft + track.scrollLeft;
    var y = lr.top - tr.top - track.clientTop + track.scrollTop;
    var first = !track.classList.contains('ss-pill-on');
    var now = Date.now();
    // a re-measure while the block is still sliding must not cut the slide short: let the transition retarget
    if (first || (!animate && now > (track.__ssAnimEnd || 0))) track.classList.add('ss-pill-instant');
    if (animate && !first) track.__ssAnimEnd = now + 600;
    pill.style.width = lr.width + 'px';
    pill.style.height = lr.height + 'px';
    // left/top (not transform): keeps the block in the normal paint layer so the photos can blend with it in Safari
    pill.style.left = x + 'px';
    pill.style.top = y + 'px';
    pill.style.opacity = '1';
    if (first) track.classList.add('ss-pill-on');
    if (track.classList.contains('ss-pill-instant')) {
      void pill.offsetWidth; // commit the instant position before transitions come back
      track.classList.remove('ss-pill-instant');
    }
    track.__ssLast = label;
  }

  function schedule(track, animate) {
    if (track.__ssRaf) cancelAnimationFrame(track.__ssRaf);
    var a = animate || track.__ssAnim;
    track.__ssAnim = a;
    track.__ssRaf = requestAnimationFrame(function () {
      track.__ssRaf = 0;
      track.__ssAnim = false;
      // a pure re-measure (resize) of the same card never animates; a different card always slides
      place(track, a && checkedLabel(track) !== track.__ssLast);
    });
  }

  function setup(track) {
    if (track.__ssPill && track.contains(track.__ssPill)) return;
    var pill = document.createElement('span');
    pill.className = 'ss-variant-pill';
    pill.setAttribute('aria-hidden', 'true');
    track.appendChild(pill);
    track.__ssPill = pill;
    track.__ssLast = null;
    track.addEventListener('change', function () { schedule(track, true); });
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].target !== pill) { schedule(track, true); return; }
      }
    }).observe(track, { subtree: true, attributes: true, attributeFilter: ['checked'], childList: true });
    if (ro) {
      ro.observe(track);
      track.querySelectorAll('.product-variant__item').forEach(function (el) { ro.observe(el); });
    }
    schedule(track, false);
  }

  function scan() { document.querySelectorAll(TRACK).forEach(setup); }

  scan();
  document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', function () { document.querySelectorAll(TRACK).forEach(function (t) { setup(t); schedule(t, false); }); });
  window.addEventListener('pageshow', function () { document.querySelectorAll(TRACK).forEach(function (t) { schedule(t, false); }); });
  // product page re-rendered by the theme (combined listings / product_url options) -> new markup, new track
  document.addEventListener('reload', function () { setTimeout(scan, 0); }, true);
  // fallback for scripts that set input.checked without an event or attribute change
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-js-product-variant], .ss-sticky-sizes, sticky-add-to-cart');
    if (t) setTimeout(function () { document.querySelectorAll(TRACK).forEach(function (tr) { schedule(tr, true); }); }, 0);
  }, true);
})();
